/** Finans UI — Faturalar (iv) ile aynı tasarım ailesi. */
export const fx = {
  bg: '#f4f6f9',
  surface: '#ffffff',
  border: '#e5eaf0',
  borderStrong: '#d0d7e2',
  text: '#0f172a',
  muted: '#64748b',
  faint: '#94a3b8',
  primary: '#0f766e',
  primaryHover: '#0d9488',
  primarySoft: 'rgba(15, 118, 110, 0.08)',
  danger: '#dc2626',
  warning: '#d97706',
  warningSoft: 'rgba(217, 119, 6, 0.1)',
  info: '#2563eb',
  success: '#059669',
  radius: '10px',
  kpi: {
    ciro: '#2563eb',
    maliyet: '#d97706',
    brut: '#0f766e',
    gider: '#dc2626',
    netUp: '#059669',
    netDown: '#dc2626',
    marj: '#0f172a',
    sabit: '#2563eb',
    degisken: '#d97706'
  }
};

export const fxCardSx = {
  bgcolor: fx.surface,
  border: `1px solid ${fx.border}`,
  borderRadius: fx.radius,
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)'
};

export const fxSectionTitleSx = {
  fontSize: 14,
  fontWeight: 800,
  color: fx.text,
  letterSpacing: '-0.01em'
};

export const fxKpiCardSx = (accent) => ({
  ...fxCardSx,
  p: { xs: 1.25, md: 1.35 },
  px: { xs: 1.2, md: 1.35 },
  minWidth: 0,
  borderLeft: `3px solid ${accent}`,
  transition: 'border-color 0.15s ease, background 0.15s ease',
  '&:hover': {
    borderColor: fx.borderStrong,
    bgcolor: '#fafbfc'
  }
});

export const fxPrimaryBtnSx = {
  textTransform: 'none',
  fontWeight: 700,
  bgcolor: fx.primary,
  boxShadow: 'none',
  '&:hover': { bgcolor: fx.primaryHover, boxShadow: 'none' }
};

export function financeScopeLabel(scope) {
  if (scope === 'product_type') return 'Ürün Tipi';
  if (scope === 'category') return 'Kategori';
  if (scope === 'product') return 'Ürün';
  if (scope === 'default') return 'Varsayılan';
  return 'Kural';
}

export function financeMethodLabel(method) {
  if (method === 'gold_formula') return 'Altın Formülü';
  if (method === 'manual_try') return 'Manuel Tutar';
  if (method === 'unit_cost') return 'Birim Maliyet';
  if (method === 'fx_cost') return 'Döviz Maliyeti';
  if (method === 'purchase_amount') return 'Alış Tutarı';
  if (method === 'ham_veri_sell') return 'Ham Veri Satış';
  if (method === 'custom') return 'Özel';
  return 'Altın Formülü';
}

export function financeGoldSourceLabel(source) {
  if (source === 'live_buy') return 'Canlı Alış';
  if (source === 'live_sell') return 'Canlı Satış';
  if (source === 'manual') return 'Manuel';
  if (source === 'product') return 'Ürün Kuru';
  return 'Canlı Alış';
}
